import axiosInstance from "./axiosInstance";
import { ENDPOINTS } from "./urls";
import { brandUiResponse } from "../utils/voiceBranding";

const ANALYTICS_REQUEST_CONFIG = { timeout: 60000 };
const PREPROD_API_BASE_URL = "https://api-test.phloz.app/";

const getPreprodUrl = (endpoint) =>
  new URL(endpoint, PREPROD_API_BASE_URL).toString();

const handleRequest = async (requestMethod, url, data = null, config = {}) => {
  try {
    const response =
      data !== null
        ? await requestMethod(url, data, config)
        : await requestMethod(url, config);
    return brandUiResponse(response.data);
  } catch (error) {
    const errorData = error.response?.data || error;
    throw typeof errorData === "string" ? brandUiResponse(errorData, "error") : brandUiResponse(errorData);
  }
};

export const get = (url, params = {}, config = {}) =>
  handleRequest(axiosInstance.get, url, null, { params, ...config });

export const getData = (url, params = {}, config = {}) =>
  handleRequest(axiosInstance.get, url, null, { params, ...config });

export const postData = (url, data, config = {}) =>
  handleRequest(axiosInstance.post, url, data, config);

export const put = (url, data, config = {}) =>
  handleRequest(axiosInstance.put, url, data, config);

export const patchData = (url, data, config = {}) =>
  handleRequest(axiosInstance.patch, url, data, config);

export const del = (url, config = {}) =>
  handleRequest(axiosInstance.delete, url, null, config);

export const getAnalyticsDashboard = () =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.DASHBOARDS),
    {},
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsOverview = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.OVERVIEW),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsContacts = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.CONTACTS),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsCampaigns = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.CAMPAIGNS),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsConversations = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.CONVERSATIONS),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsAgents = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.AGENTS),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsDelivery = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.DELIVERY),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsTags = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.TAGS),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsAutomation = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.AUTOMATION),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsWaba = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.WABA),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsWasync = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.WASYNC),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsInstagram = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.INSTAGRAM),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsVoice = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.VOICE),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsWorkflows = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.WORKFLOWS),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsAttention = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.ATTENTION),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsTrends = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.TRENDS),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsSalesCrm = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.SALESCRM),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsTeam = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.TEAM),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsMyDay = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.MY_DAY),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const postAnalyticsRefresh = (params = {}) =>
  postData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.REFRESH),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsCalls = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.CALLS),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const getAnalyticsVoicecall = (params = {}) =>
  getData(
    getPreprodUrl(ENDPOINTS.ANALYTICS.VOICECALL),
    params,
    ANALYTICS_REQUEST_CONFIG
  );

export const postFile = (url, file, config = {}) => {
  const formData = new FormData();
  formData.append("file", file);

  return handleRequest(axiosInstance.post, url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    ...config,
  });
};

export const APIs = {
  upload: "chatapp/uploadFile?accountId=1&userId=undefined",
  error: "aviate/JSError/",
  fetchWorkFlows: "flow/v2/flow",
  whatsappTemplate: "whatsapp/templates",
};
